import { branch, compose, renderNothing, withHandlers, withPropsOnChange } from 'recompose';
import moment from 'moment-timezone';
import { connect } from 'react-redux';

import WithAnyBarber from '../../hoc/WithAnyBarber';
import WithFetchAvailability from '../../hoc/WithFetchAvailability';
import WithTimezone from '../../hoc/WithTimezone';
import {
  getActiveDay,
  getNextAvailableTime,
  getNextUnfetchedDayUpToAdvanceBookDays,
  getTimeOrItem,
} from '../selectors';
import WithAdvanceBookDays from '../../hoc/WithAdvanceBookDays';
import { mapTimes } from '../../utils/helpers';
import config from '../../../config';
import NextAvailableButton from '../components/NextAvailableButton';

export default compose(
  WithAnyBarber,
  WithAdvanceBookDays,
  WithTimezone,
  WithFetchAvailability,
  connect((state, ownProps) => {
    const activeDay = getActiveDay(state);
    return {
      nextAvailableTime: getNextAvailableTime(state, activeDay, ownProps.timezone),
      nextUnfetchedDay: getNextUnfetchedDayUpToAdvanceBookDays(state, ownProps.advanceBookDays),
      activeDay,
    };
  }),
  withHandlers({
    onClick: props => () => {
      const time = getTimeOrItem(props.nextAvailableTime);
      props.setActiveDay(moment.tz(time, props.timezone).startOf('day').format(config.apiDateFormat));
      props.setTime(mapTimes(props.nextAvailableTime))();
    },
  }),
  withPropsOnChange(['activeDay', 'nextAvailableTime', 'nextUnfetchedDay'], (props) => {
    if (props.activeDay && !props.nextAvailableTime && props.nextUnfetchedDay) {
      const nextAvailableTimeFetchInterval = props.anyBarber
        ? config.nextAvailableTimeFetchInterval.shop
        : config.nextAvailableTimeFetchInterval.barber;
      props.fetchAvailability(
        props.nextUnfetchedDay,
        moment(props.nextUnfetchedDay)
          .add(nextAvailableTimeFetchInterval)
          .format(config.apiDateFormat),
      );
    }
  }),
  branch(props => !props.nextAvailableTime, renderNothing),
)(NextAvailableButton);



// WEBPACK FOOTER //
// ./src/app/times/containers/NextAvailableButton.js